import { InputTableLayoutData } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { OrderData } from '../types'

export const parseSelectedTableData = (completeData: InputTableLayoutData) => {
    const parsedData: OrderData = JSON.parse(JSON.stringify(completeData))
    const isSelectedTableData = parsedData?.selectedTableData && parsedData?.selectedTableData?.length ? true : false
    if (!isSelectedTableData) {
        return parsedData?.tableData
    }
    const myTableData = parsedData?.selectedTableData?.length ? parsedData?.selectedTableData : parsedData?.tableData
    const result = []
    for (const element of myTableData) {
        let myElement = element
        if (isSelectedTableData && parsedData?.dictPosTableData?.[myElement.id] !== undefined) {
            myElement = parsedData?.tableData[parsedData?.dictPosTableData?.[myElement.id]]
        }
        if (!myElement.processed && myElement.OrderId && myElement?.type !== "addButton") {
            result.push(myElement)
        }
    }
    return result
}